import { MachineActions } from 'common/bento/types/MachineConfig';
import logger from 'helpers/logger';

import researchExperimentStorage from '../storage/researchExperiment';
import { Model } from './model';

export enum Action {
  SaveResearchExperimentSeen = 'saveResearchExperimentSeen',
  LogError = 'logError',
}

const actions: MachineActions<Model, Action> = {
  logError: (context, event) => {
    logger.error('An error occurred in the ResearchExperiment module', {
      context: { eventType: event.type },
    });
  },

  saveResearchExperimentSeen: () => {
    researchExperimentStorage.set();
  },
};

export default actions;
